// extracted by mini-css-extract-plugin
module.exports = {"injuredField":"ContactComponent_injuredField__2Bs_O","phoneNumberField":"ContactComponent_phoneNumberField__3mswH","involvementField":"ContactComponent_involvementField__2dlcN"};